module.exports = " <span> <button class=\"c-tablist__tab-title c-heading\" role=tab :class=\"{ 'c-tablist__tab-title--active' : open }\" :aria-controls=\"'tablist-' + name\" :aria-selected=\"'' + open\" :id=\"'tab-' + name\" @click=\"$emit('input', name)\"> <span>{{ title }}</span> </button> <div class=\"i-icon i-grey-bullet c-tablist__bullet\" v-if=\"name !== 'discussion'\" role=presentation></div> </span> ";


//////////////////
// WEBPACK FOOTER
// ./src/frontend/pages/explore-the-archive/archive/templates/tab-button.html
// module id = 159
// module chunks = 0